import AccessDenied from "../components/View/AccessDenied";
import DecryptData from "./Decrypt";

export function GetRole(){
    const userData = localStorage.getItem("aTaDrEsU")?DecryptData("aTaDrEsU"):[];    
    const role = userData?.role[0].roleName;
    if(role ==="scroll_admin"||role==="admin"){
        return true
    }else{
        return false
    }
}

export function GetSuperAdmin(){
    const userData = localStorage.getItem("aTaDrEsU")?DecryptData("aTaDrEsU"):[];    
    const role = userData?.role[0].roleName;
    if(role ==="scroll_admin"){
        return true
    }else{
        return false
    }
}

export function GetUserStandard(){
    const userData = localStorage.getItem("aTaDrEsU")?DecryptData("aTaDrEsU"):[];
    return userData?.standards||[];
}

export function GetAccess(accessText){
    const userAccess = localStorage.getItem("nOiSsImRePrEsU")?DecryptData("nOiSsImRePrEsU"):[];
    if(GetRole()){
        return true
    }else{        
        const access = userAccess?userAccess.some((permission)=>permission.permissionName == accessText ):false;
        return access;
    }
}

export function GetUserDetails(){
    const userData = localStorage.getItem("aTaDrEsU")?DecryptData("aTaDrEsU"):[];
    let UserId = userData?.userId||"";
    let Name = userData?.name||"";
    let UserImage = userData?.image_path||"";
    let userName = userData?.user_name||"";
    return {UserId,Name,UserImage,userName};
}

export function RendorPage(accessKey,Component){
    const userAccess = localStorage.getItem("yEkSseCcaReSu")?DecryptData("yEkSseCcaReSu"):[];
    if( (GetSuperAdmin()||userAccess.some((permission) => permission == accessKey)) == true){
        return <Component/>
    }else{
        return <AccessDenied hasSubcribe={true}/>
    }
    }


export function Wrapper({accessKey,Component}){
    return RendorPage(accessKey, Component);
  }


  export function AdminRendorPage(accessKey,Component){
    const userAccess = localStorage.getItem("yEkSseCcaReSu")?DecryptData("yEkSseCcaReSu"):[];
    if( (GetSuperAdmin()||userAccess.some((permission) => permission == accessKey)) == true){
        return <Component/>
    }else{
        return <AccessDenied/>
    }
    }


export function AdminWrapper({accessKey,Component}){
    return RendorPage(accessKey, Component);
  }
